export const DESTROY_SESSION             = 'DESTROY_SESSION';
export const SET_SESSION_CONTACT_ID      = 'SET_SESSION_CONTACT_ID';
export const SET_SESSION_EXIST           = 'SET_SESSION_EXIST';
export const SET_SESSION_SELECTED_TENANT = 'SET_SESSION_SELECTED_TENANT';
export const SET_SESSION_TENANTS         = 'SET_SESSION_TENANTS';
export const SET_SESSION_USER            = 'SET_SESSION_USER';
